const en = {
  home: {
    // HoneView.vue
    cancelSubscriptionSuccess: "You are no longer subscribe our newletters.",
    cancelSubscriptionFail: "Your operation is failed. Please try again.",
    // TopBannerComponent.vue
    topBanner: "Banner of the top",
    // BannerComponent.vue
    slideImg: "Image of the slideshow",
    title1: "P360 Smartcap",
    title2: "Protection from viruses and pollutants",
    subtitle1: "Invisible hepa + ionic shield",
    subtitle2: "Covering face to protect every breath you take!",
    knowMore: "Know More",
    // award section
    awardTitle: "Awards",
    award1: "Most Creative Award - SME IP Innovation Base",
    award2: "Retail Innovation Award 2022",
    award3: "Silver Award - Asia International Innovation Invention Award",
    // IntroComponent.vue
    intro:
      "The SmartCap presents you a technological breakthrough, after activating the cap, it’s Ionic wind and Hepa Filter will get rid of most viruses and harmful elements from your face. Theoretically, it will recharge yourblood’s oxygen level and obtain headaches reduction.",
    buyNow: "Buy Now",
    youtubeTitle: "YouTube video player",
    detailsTitle: "What special?",
    details1:
      "P360 Smart cap protect you from pollutant and virus. P360 innovative engine is running with Hepa filter and ionic generator onto the cap. No one knows you are under special protection!",
    details2:
      "HEPA filter will eliminate harmful particles and bacteria or even pollen particles to relief pollen allergy.",
    details3:
      "Ionic emitter generates ions directly onto your face which is highly protecting you rather than others ion necklace from the market.",
    details4:
      "Rotation fan keep blowing ionized and filtrated clean air onto face directly.",
    details5: "Protection up to 5 hours with fully charge battery.",

    smartCap: "P360 SmartCap ✔",
    otherProducts: "Portable Air Purifier Necklace",
    wearPosition: "Efficiency",
    wearPositionSmartCap:
      "Devices are located on the front panel of cap. It forms an invisible shield covering the face.",
    wearPositionOther:
      "Hanging on the chest. Most of the purified air may not reach to the face.",
    hidden: "Other's attention",
    hiddenSmartCap:
      "Air purifying devices is hidden. No one will realize you are under protection.",
    hiddenOther: "It is noticeable.",
    filteringMedium: "Filters",
    filteringMediumSmartCap: "Ionic generator + HEPA Filter + Sensors",
    filteringMediumOther: "Ionic generator only",
    productPrice: "Price",
    productPriceSmartCap: "USD$99 (early bird offer)",
    productPriceOther: "> 128USD",
    // CancelSubscriptionComponent.vue
    cancelSubscriptionTitle1: "Are you sure you want to",
    cancelSubscriptionTitle2: " unsubscribe our newletter?",
    cancelSubscriptionConfirm: "Confirm",
  },
  aboutUs: {
    title: "P360 Technology",
    subtitle: "Protect you in 360°",
    intro1Title: "P360 Technology",
    intro1:
      "P360 is an innovative company established in 2019. With the latest technology, P360 can let you breathe fresh air with no restriction of time and place. A negative ion shield is formed around you when you stay outside just by wearing a fashionable cap. As such, lets us protect your health.",
    intro2Title: "P360 Team",
    intro2:
      "We are an energetic team consisting of the technology sector and engineering sector. People around the world had been infected with the coronavirus (including some of us). It is important to keep an eye on health. That’s the reason why we are providing solutions-based health care products.",
    intro3Title: "P360’s Mission",
    intro3:
      "Our mission lies in protecting you in 360 degrees. In an age where virus threatens the lives of our community, we aim to create a safe environment by emphasizing the precautions and safety of our customers.",
  },
  product: {
    // GoToShoppingCartComponent.vue
    goToShoppingCartConfirm: "Go to shopping cart",
    // PaymentConirmComponent.vue
    purchaseConfirm: "Confirm",
    // ProductComponent.vue
    carouselAlt: "Product Image in Slideshow",
    carouselPrevious: "Previous",
    carouselNext: "Next",
    currencyCode: "USD",
    share: " Share",
    colour: "Color:",
    outOfStock: "Out of stock",
    quantity: "Product Quantity",
    pieces: "pcs",
    purchase: "Purchase",
    addToShoppingCart: "Add to shopping cart",
    details: "Details",
    specs: "Specs",
    manual: "Manual",
    manualImgText: "User Manual",
    manualDownload: "Click here to download",
    interest: "Product you may interest",
    outOfStockMsg:
      "This product is out-of-stock, but it is in the Presales. Click <a href='/'>here</a> to know more!",
    // ProductInfoComponent.vue
    unitPrice: "Unit Price:",
    totalPrice: "Total Price:",
    quantity2: "Quantity:",
    // ShareComponent.vue
    clipboardHint: "one click to copy",
    ogDescription: "Buy it now!",
    copiedHint: "Copied",
    whatsappAlt: "share this product to whatsapp",
    facebookAlt: "share this product to facebook",
    twitterAlt: "share this product to twitter",
  },
  shoppingCart: {
    // ShoppingCartView.vue
    voucherCodeShortText: "Vocher Code",
    voucherCodeLongText: "Enter Your Vocher Code",
    title: "Shopping Cart",
    currencyCode: "@:product.currencyCode",
    pieces: "@:product.pieces",
    noProduct: "No products added in shopping cart.",
    subTotal: "Sub total",
    voucherCode: "Voucher Code",
    checkOut: "Check out with",
  },
  trackNTrace: {
    // CheckOrderView.vue
    formTitle: "Check Your Order",
    formText: "Please enter your email and order number.",
    email: "Email:",
    emailPlaceholder: "Email you used during checkout",
    invalidEmail: "Invalid Email",
    orderNumber: "Order Number:",
    orderNumberPlaceholder: "Order number",
    invalidOrderNumber: "Invalid Order Number",
    formConfirm: "Confirm",
    // OrderStatusView.vue
    productPhoto: "Product Photo",
    orderId: "Order ID",
    datePaid: "Date Paid",
    shippingAddress: "Shipping Via",
    shippingStatusOrdered: "Ordered",
    shippingStatusShipped: "Shipped",
    shippingStatusOutOfDelivery: "Out of delivery",
    shippingStatusArrived: "Arrived",
  },
  footer: {
    // FooterComponent.vue
    subscriptionSuccess: "Your have subscribed our newletters!",
    subscriptionFailed: "Fail to subscribe our newletters. Please try again.",
    emailSend: "Send",
    emailLoading: "Loading...",
    validEmail: "Success!",
    invalidEmail: "Invalid email or message.",
    subscriptionTitle: "Sign up for p360's Newsletter",
    subscriptionText:
      "Sign up to receive exclusive offers and new product directly from p360.",
    subscriptionRegister: "Register",
    subscriptionGoogle: "Connect With Google",
    socialMediaTitle: "Follow Us | Social Media",
    socialMediaFacebook: "Our Facebook Page",
    socialMediaInstagram: "Our Instagram Page",
    socialMediaYoutube: "Our Youtube Channel",
    contactUs: "Contact Us",
    emailAddressPlaceholder: "Enter your email...",
    emailContentPlaceholder: "Leave your message here...",
    phoneNumber: "Phone:",
    emailAddress: "Email:",
    address: "Address:",
    patentNumber: "Patent Number:",
    copyright1: "Copyright",
    copyright2: ". All rights reserved.",
    sponsored: "Sponsored",
    "Sponsored#1": "HKSTP Self Develop Skincare",
    "Sponsored#2": "HKSTP Self Develop EV Charging",
    "Sponsored#3": "HKSTP Self Develop SmartCap",
    "Sponsored#4": "HKSTP Self Develop Ridehailing",
  },
  header: {
    // HeaderComponent.vue
    buyNow: "Buy Now",
    aboutUsLong: "About P360 Technology",
    shoppingCart: "Shopping Cart",
    orderTracking: "Order Tracking",
    aboutUsShort: "About Us",
  },
  shippingAddressForm: {
    // ShippingAddressComponent.vue
    title1: "Shipping Address",
    name: "Name:",
    email: "Email:",
    line1: "Line 1:",
    line2: "Line 2:",
    city: "City:",
    state: "State:",
    country: "Country:",
    postalCode: "Postal Code:",
    hint1: "* required",
    hint2: '^ fill "000000" if you don\'t know / have postal code',
    nextStep: "Next Step",
    title2: "Shipping To ",
    currencyCode: "@:product.currencyCode",
    previousStep: "Previous Step",
    submitLoading: "Loading...",
    submitNormal: "Submit",
    require: "(required)",
    emailNotValid: "(email format is not valid)",
    serverError: "(server error. please try again.)",
  },
  payment: {
    // StripeComponent.vue
    unexpectedError: "An unexpected error occurred.",
    paymentStatusSucceeded: "Payment succeeded!",
    paymentStatusProcessing: "Your payment is processing.",
    paymentStatusRequires: "Your payment was not successful, please try again.",
    paymentStatusError: "Something went wrong.",
    currencyCode: "@:product.currencyCode",
    totalPrice: "Total Price:",
    stripeLoading: "Loading...",
    stripePayNow: "Pay now",
    // PaymentFinishedComponent.vue
    paymentFinishedTitle: "Thank your for your purchase !",
    paymentFinishedId: "Your order ID is ",
    paymentFinishedReceipt:
      "An receipt will been send to {receiptEmail} later.",
    goShopping: "Go shopping",
    saveAsImg: "Save as image",
    tnt: "Trace and Track",
    paymentNotFinished: "Please try again.",
  },
  subscription: {
    // SubscriptionComponent.vue
    formTitle: "Subscribe our newletters",
    formName: "Your name:",
    formEmail: "Your email address:",
    formSubmit: "Submit",
  },
};

const enNumberFormats = {
  currency: {
    style: "currency",
    currency: "USD",
    currencyDisplay: "symbol",
    useGrouping: true,
  },
};

export { en, enNumberFormats };
